import { h } from 'vue';

function wrapper(nodeName, attributes, ...children) {
  if (typeof nodeName === "object") {
    children.unshift(attributes);
    attributes = nodeName;
    nodeName = "span";
  }
  return h(
    nodeName,
    {
      ...attributes,
      class: attributes.class ? `se-element-wrapper ${attributes.class}` : "se-element-wrapper"
    },
    children
  );
}

export { wrapper };
//# sourceMappingURL=wrapper.js.map
